import axios from 'axios'

export function computePlatformApiEndpoint(baseUrl, prSuffix, reviewType) {
  // Review App Support
  if (prSuffix && reviewType === 'ep-review') {
    return baseUrl.replace(
      '.elevatesecurity-staging.com',
      `${prSuffix}.ep-review.elevatesecurity-staging.com`
    )
  }
  return baseUrl
}

const [subdomain, reviewType] = window.location.host.split('.')
const [, tenant, prSuffix] = subdomain.match(/^(.*?)(-(pr-[0-9]+))?$/)

axios.defaults.withCredentials = true
axios.defaults.headers.common = { 'X-Tenant': tenant }

const impersonate_es_person_id = localStorage.getItem('impersonate_es_person_id')
if (impersonate_es_person_id !== null) {
  axios.defaults.headers['X-Impersonate-User'] = impersonate_es_person_id
}

axios.defaults.baseURL = computePlatformApiEndpoint(
  process.env.REACT_APP_SERVER_URL,
  prSuffix,
  reviewType
)
axios.tenant = tenant
